// extracted by mini-css-extract-plugin
export default {"cheating_wrapper":"cheating_cheating_wrapper__IQ4w2","text":"cheating_text__W6GZ0"};